import { USER } from 'constants/ssr';

let userId;

function hijackConsoleFunction(functionString) {
  const originalFunction = window.console[functionString];

  window.console[functionString] = function () {
    const argumentsArray = Array.from(arguments);
    const ddArgs = [];

    function processArgsCallback(arrayToPushTo) {
      return function (logArg) {
        if (logArg instanceof Error) {
          // we do this check because stack is non-standard, yet highly supported
          // and gives us much better visibility into errors:
          //
          // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Stack
          if (logArg.stack != null) {
            arrayToPushTo.push(logArg.stack);
          } else {
            arrayToPushTo.push(logArg.toString());
          }
        } else {
          try {
            // try to serialize the arg to JSON before to catch whether there is
            // a circular object reference
            const strLogArg = JSON.stringify(logArg);

            arrayToPushTo.push(strLogArg);
          } catch (err) {
            if (logArg.toString) {
              arrayToPushTo.push(logArg.toString());
            } else {
              arrayToPushTo.push('non-serializable arg');
            }
          }
        }
      };
    }

    argumentsArray.forEach(processArgsCallback(ddArgs));

    if (!userId) {
      const user = window[USER] || {};
      const analytics = window.analytics || {};

      userId = user?.id || analytics?.user?.()?.id?.();
    }

    Reflect.apply(originalFunction, window, arguments);
  };
}

export const init = () => {
  if (window && window.console.error) {
    hijackConsoleFunction('error');
  }

  if (window && window.console.log) {
    hijackConsoleFunction('log');
  }

  if (window && window.console.warn) {
    hijackConsoleFunction('warn');
  }

  if (window && window.console.debug) {
    hijackConsoleFunction('debug');
  }
};
